export const AUTH_REFRESH_INTERVAL = 1000 * 60 * 9.5; // 9 min 30 seconds



// WEBPACK FOOTER //
// ./src/constants/AuthTypes.js